import styled, { css } from 'styled-components'

import { colors } from '../../styles/colors'
import dimensions from '../../styles/dimensions'
import { IStyledButtonProps } from './ButtonComponent.types'

export const StyledButton = styled.button<IStyledButtonProps>`
  display: flex;
  justify-content: ${props => props.justifyContent || 'center'};
  align-items: ${props => props.alignItems || 'center'};
  height: ${dimensions.componentHeight.large}px;

  background: ${props => (props.$transparent ? 'transparent' : props.$color)};
  color: ${props => (props.$fontColor ? props.$fontColor : colors.white)};
  font-weight: 700;
  font-size: 14px;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      background-color: ${colors.grayLight};
      color: ${colors.white};
    `}

  ${props =>
    props.$size === 'small' &&
    css`
      width: 81px;
    `}

  ${props =>
    props.$size === 'medium' &&
    css`
      width: 120px;
    `}

  ${props =>
    props.$size === 'large' &&
    css`
      width: 159px;
    `}

  border-radius: 4px;
  border: 0;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }

  svg {
    margin-right: 5px;
  }
`
